module.exports = __webpack_public_path__ + "img/miles.e49bf4cc.png";